export default {
    planModulesTitle: 'Plan modules and attributes',
    planModulesSubtitle: 'Enable the modules included in the plan and configure their limits',
    moduleIncluded: 'Included',
    moduleNotIncluded: 'Not included',
    attributesTitle: 'Attributes',
    noAttributesConfigured: 'This module has no configured attributes yet',
    saveAttribute: 'Save',
    attributeUpdated: 'Attribute saved successfully',
    attributeError: 'Error saving the attribute',
    moduleEnabledMsg: 'Module included in the plan',
    moduleDisabledMsg: 'Module removed from the plan',
    moduleError: 'Error updating the plan module',
    confirmDisableModule: 'Remove this module from the plan? Its configured attributes will be kept.',
    enableEditFirst: 'Enable editing to modify the plan modules',
    errorLoadingModules: 'Error loading the plan modules',
    booleanIncluded: 'Included',
    booleanNotIncluded: 'Not included',
    instantSaveNote: 'Module and attribute changes are saved instantly',
    plansTitle: 'Plans',
    planInformation: 'Plan information',
    newPlan: 'New plan',
    editPlan: 'Edit plan',
    createPlan: 'Create plan',
    saveChanges: 'Save changes',
    active: 'Active',
    planCodePlaceholder: 'e.g. basic',
    billingPeriod: 'Billing period',
    selectBillingPeriod: 'Select period',
    name_es: 'Name (Spanish)',
    nameEsPlaceholder: 'Name in Spanish',
    name_en: 'Name (English)',
    nameEnPlaceholder: 'Name in English',
    description_es: 'Description (Spanish)',
    descriptionEsPlaceholder: 'Description in Spanish',
    description_en: 'Description (English)',
    descriptionEnPlaceholder: 'Description in English',
    price: 'Price',
    pricePlaceholder: '0.00',
    currency: 'Currency',
    selectCurrency: 'Select currency',
    displayOrder: 'Display order',
    targetProfile: 'Target profile',
    targetProfilePlaceholder: 'e.g. SMEs, mid-size companies',
    assignedTenants: 'Assigned tenants',
    compareTitle: 'Compare plans',
    compareSubtitle: 'Select 2 to 4 plans to compare them side by side',
    selectPlansToCompare: 'Select plans (2 to 4)',
    compareButton: 'Compare',
    compareAction: 'Compare plans',
    noComparison: 'Select at least 2 plans and press Compare',
    compareMinPlans: 'Select at least 2 plans to compare',
    compareLoadError: 'Error comparing the plans',
    featureColumn: 'Feature',
    attention: 'Attention!',
    loadingPlan: 'Loading plan...',
    creatingPlan: 'Creating plan...',
    savingChanges: 'Saving changes...',
    planCreated: 'Plan created successfully',
    planUpdated: 'Plan updated successfully',
    errorLoadingPlan: 'Error loading the plan',
    errorCreatingPlan: 'Error creating the plan',
    errorUpdatingPlan: 'Error updating the plan',
};
